import React from 'react';
import MainInfoTracLayout from '../../components/Layout/Main';
import Content from '../../components/Pages/ReturnMail';

function ReturnMail() {
  return (
    <MainInfoTracLayout className="min-h-[100vh]" isOldPage>
      <Content />
    </MainInfoTracLayout>
  );
}

export default ReturnMail;
